// extracted by mini-css-extract-plugin
export default {"container":"Fact_container__vGJ3s","title":"Fact_title__ZIqQX","body":"Fact_body__cGd5k"};